const IMAGE_JPEG_QUALITY = 0.85;

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', () => reject(new Error('image-load-failed')));
    image.src = src;
  });

const getOutputFormat = (fileName) => {
  const name = String(fileName || '').toLowerCase();
  return name.endsWith('.png')
    ? { mimeType: 'image/png', extension: 'png' }
    : { mimeType: 'image/jpeg', extension: 'jpg' };
};

export const cropImageToFile = async (imageSrc, pixelCrop, fileName = 'image.jpg') => {
  if (!imageSrc || !pixelCrop) {
    throw new Error('image-crop-failed');
  }

  const image = await loadImage(imageSrc);
  const width = Math.max(1, Math.round(pixelCrop.width));
  const height = Math.max(1, Math.round(pixelCrop.height));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('image-crop-failed');
  }

  const { mimeType, extension } = getOutputFormat(fileName);
  context.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    width,
    height,
  );

  const blob = await new Promise((resolve, reject) => {
    const callback = (result) => (
      result ? resolve(result) : reject(new Error('image-crop-failed'))
    );
    if (mimeType === 'image/jpeg') {
      canvas.toBlob(callback, mimeType, IMAGE_JPEG_QUALITY);
    } else {
      canvas.toBlob(callback, mimeType);
    }
  });

  const baseName = String(fileName || 'image').replace(/\.[^.]+$/, '');
  return new File([blob], `${baseName}.${extension}`, {
    type: mimeType,
    lastModified: Date.now(),
  });
};
